import React, { Suspense } from "react";
import { Card, CardHeader, CardContent, Grid } from "@mui/material";
import {
  VehicleGroupsDataGrid,
  VehicleGroupsStats,
} from "../components/vehicle";
import StatSkeleton from "../components/common/StatSkeleton";
import CreateVehicleGroupTile from "../components/vehicle/group/CreateVehicleGroupTile";

const VehicleGroups = () => {
  return (
    <div className="fragmentContainer">
      <Grid container spacing={2}>
        <Suspense fallback={<StatSkeleton />}>
          <VehicleGroupsStats />
        </Suspense>
        <CreateVehicleGroupTile />
        <Grid item xs={12} md={12}>
          <Card>
            <CardContent
              sx={{
                padding: 0,
                ":last-child": {
                  padding: 0,
                },
              }}
            >
              <VehicleGroupsDataGrid tableTitle="Available Vehicle Groups" />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default VehicleGroups;
